import { createReducer, on } from '@ngrx/store';
import * as ProductCategoriesActions from './product-categories.actions';
import { initialProductCategoriesState } from './product-categories.state';

export const productCategoriesReducer = createReducer(
  initialProductCategoriesState,

  on(ProductCategoriesActions.loadProductCategories, (state, { params }) => ({
    ...state,
    params: { ...state.params, ...params },
    loading: true,
    error: null,
  })),

  on(ProductCategoriesActions.loadProductCategoriesSuccess, (state, { response }) => ({
    ...state,
    categories: response.items,
    total: response.total,
    page: response.page,
    limit: response.limit,
    totalPages: response.totalPages,
    loading: false,
    error: null,
  })),

  on(ProductCategoriesActions.loadProductCategoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProductCategoriesActions.createProductCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProductCategoriesActions.createProductCategorySuccess, (state, { category }) => ({
    ...state,
    categories: [ ...state.categories, category ],
    loading: false,
    error: null,
  })),

  on(ProductCategoriesActions.createProductCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProductCategoriesActions.updateProductCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProductCategoriesActions.updateProductCategorySuccess, (state, { category }) => ({
    ...state,
    categories: state.categories.map(item => item.id === category.id ? category : item),
    loading: false,
    error: null,
  })),

  on(ProductCategoriesActions.updateProductCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ProductCategoriesActions.deleteProductCategory, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(ProductCategoriesActions.deleteProductCategorySuccess, (state, { id }) => ({
    ...state,
    categories: state.categories.filter(item => item.id !== id),
    loading: false,
    error: null,
  })),

  on(ProductCategoriesActions.deleteProductCategoryFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
